/**
 * What putting an athlete under an agent writes.
 *
 * A client carries three owner fields (agent_owner_id, assigned_agent_id,
 * owner_id), and "Mine" counts an athlete as yours if ANY of them names you
 * (utils/athleteScope isOwnedBy). So a move has to write all three: the app's
 * reassign used to write two and leave owner_id on the person who created the
 * record, and the athlete stayed in that person's Mine as well as landing in
 * the new agent's. The app and the Claude connector both go through this.
 * Pure; no network.
 */

export function clientOwnerPatch(agentId: string | null) {
  return { agent_owner_id: agentId, assigned_agent_id: agentId, owner_id: agentId }
}
